import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../../options/services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setServicesBilling } from '../store/completeChart.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { initialServicesBillingState } from '../store/completeChart.reducers'

export function* getServicesBilling() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getServicesBillingOptions])
    yield put(setServicesBilling(response?.entity?.[0] ?? initialServicesBillingState))
  } catch (e) {
    yield put(throwPcrException(`getServicesBilling() error: ${e}`))
  }
}
export function* getServicesBillingSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], performWithMutexHOG, getServicesBilling)
}
